import React from "react";
import s from './ButtonWithIcon.module.scss'

export const ButtonWithIcon = ({onClick = () => {}, value="", disabled, icon, green=false, grey=false, red=false, transparent=false }) => {
    return <button onClick={onClick} className={`${green ? s.green : ''} ${grey ? s.grey : ''} ${red ? s.red : ''} ${transparent ? s.transparent : ''} ${s.formButton}`} disabled={disabled}>{icon && <img src={icon} alt="icon" />}{value}</button>
}